export enum AuctionCatalogueStatusEnum {
    Active = 1,
    Completed = 2,
    BidAcceptance = 3,
    ReOffered = 4,
    Withdrawn = 5,
    ClosingShortly = 6
}
